export default __webpack_public_path__ + "static/media/eye on.4b6169a2.svg";